export const activityLogEntriesSelector = (organizationKey) => state => organizationKey ? state.activityLog[organizationKey] : null;
